module.exports = __webpack_public_path__ + "static/media/jaune.8f34873b.png";